/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentVersionWithRelations } from './normativeDocumentVersionWithRelations';
import { CompanyWithRelations } from './companyWithRelations';
import { NormativeDocumentTypeWithRelations } from './normativeDocumentTypeWithRelations';
import { UserWithRelations } from './userWithRelations';
import { NormativeAreaWithRelations } from './normativeAreaWithRelations';


/**
 * (tsType: NormativeDocumentWithRelations, schemaOptions: { includeRelations: true })
 */
export interface NormativeDocumentWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    /**
     * Código oficial <AREA>-<###>-<TIPO> (ej. OPE-001-PR). Derivado del área, el tipo y el consecutivo. Único entre los activos de la empresa y corregible en cualquier momento
     */
    code: string;
    companyId: string;
    areaId: string;
    typeId: string;
    /**
     * Consecutivo dentro de la combinación empresa + área + tipo. Se escribe a mano y se reusa: un documento dado de baja libera su número
     */
    sequence: number;
    /**
     * true = el consecutivo lo escribió una persona, no lo propuso el sistema
     */
    sequenceManual?: boolean;
    name: string;
    description?: string;
    /**
     * Palabras clave para el buscador, separadas por coma
     */
    keywords?: string;
    /**
     * Responsable del documento: elabora versiones y recibe los avisos
     */
    ownerUserId?: number;
    /**
     * Es la baja del documento completo, distinta del estado de cada versión. Solo los activos ocupan consecutivo y salen en el listado
     */
    status: NormativeDocumentWithRelations.StatusEnum;
    /**
     * true = solo lo ven quienes tengan una excepción en normative_document_permissions
     */
    restricted?: boolean;
    /**
     * Hereda de allowDownloadDefault del tipo y el administrador lo ajusta
     */
    allowDownload?: boolean;
    /**
     * Contraseña opcional del documento. Capa EXTRA sobre el permiso, nunca lo reemplaza
     */
    passwordHash?: string;
    /**
     * Atajo a la versión vigente
     */
    currentVersionId?: string;
    company?: CompanyWithRelations;
    area?: NormativeAreaWithRelations;
    type?: NormativeDocumentTypeWithRelations;
    owner?: UserWithRelations;
    versions?: Array<NormativeDocumentVersionWithRelations>;
}
export namespace NormativeDocumentWithRelations {
    export type StatusEnum = 'activo' | 'obsoleto';
    export const StatusEnum = {
        Activo: 'activo' as StatusEnum,
        Obsoleto: 'obsoleto' as StatusEnum
    };
}


